export const Countries = [
  { option: "Select Country", value: "" },
  { option: "Afghanistan", value: "AF" },
  { option: "Albania", value: "AL" },
  { option: "Algeria", value: "DZ" },
  { option: "Andorra", value: "AD" },
  { option: "Angola", value: "AO" },
  { option: "Antigua and Barbuda", value: "AG" },
  { option: "Argentina", value: "AR" },
  { option: "Armenia", value: "AM" },
  { option: "Australia", value: "AU" },
  { option: "Austria", value: "AT" },
  { option: "Azerbaijan", value: "AZ" },
  { option: "Bahamas", value: "BS" },
  { option: "Bahrain", value: "BH" },
  { option: "Bangladesh", value: "BD" },
  { option: "Barbados", value: "BB" },
  { option: "Belarus", value: "BY" },
  { option: "Belgium", value: "BE" },
  { option: "Belize", value: "BZ" },
  { option: "Benin", value: "BJ" },
  { option: "Bhutan", value: "BT" },
  { option: "Bolivia", value: "BO" },
  { option: "Bosnia and Herzegovina", value: "BA" },
  { option: "Botswana", value: "BW" },
  { option: "Brazil", value: "BR" },
  { option: "Brunei", value: "BN" },
  { option: "Bulgaria", value: "BG" },
  { option: "Burkina Faso", value: "BF" },
  { option: "Burundi", value: "BI" },
  { option: "Cambodia", value: "KH" },
  { option: "Cameroon", value: "CM" },
  { option: "Canada", value: "CA" },
  { option: "Cape Verde", value: "CV" },
  { option: "Central African Republic", value: "CF" },
  { option: "Chad", value: "TD" },
  { option: "Chile", value: "CL" },
  { option: "China", value: "CN" },
  { option: "Colombia", value: "CO" },
  { option: "Comoros", value: "KM" },
  { option: "Congo", value: "CG" },
  { option: "Congo (DRC)", value: "CD" },
  { option: "Costa Rica", value: "CR" },
  { option: "Côte d’Ivoire", value: "CI" },
  { option: "Croatia", value: "HR" },
  { option: "Cuba", value: "CU" },
  { option: "Cyprus", value: "CY" },
  { option: "Czech Republic", value: "CZ" },
  { option: "Denmark", value: "DK" },
  { option: "Djibouti", value: "DJ" },
  { option: "Dominica", value: "DM" },
  { option: "Dominican Republic", value: "DO" },
  { option: "Ecuador", value: "EC" },
  { option: "Egypt", value: "EG" },
  { option: "El Salvador", value: "SV" },
  { option: "Equatorial Guinea", value: "GQ" },
  { option: "Eritrea", value: "ER" },
  { option: "Estonia", value: "EE" },
  { option: "Ethiopia", value: "ET" },
  { option: "Fiji", value: "FJ" },
  { option: "Finland", value: "FI" },
  { option: "France", value: "FR" },
  { option: "Gabon", value: "GA" },
  { option: "Gambia", value: "GM" },
  { option: "Georgia", value: "GE" },
  { option: "Germany", value: "DE" },
  { option: "Ghana", value: "GH" },
  { option: "Greece", value: "GR" },
  { option: "Grenada", value: "GD" },
  { option: "Guatemala", value: "GT" },
  { option: "Guinea", value: "GN" },
  { option: "Guinea-Bissau", value: "GW" },
  { option: "Guyana", value: "GY" },
  { option: "Haiti", value: "HT" },
  { option: "Honduras", value: "HN" },
  { option: "Hungary", value: "HU" },
  { option: "Iceland", value: "IS" },
  { option: "India", value: "IN" },
  { option: "Indonesia", value: "ID" },
  { option: "Iran", value: "IR" },
  { option: "Iraq", value: "IQ" },
  { option: "Ireland", value: "IE" },
  { option: "Israel", value: "IL" },
  { option: "Italy", value: "IT" },
  { option: "Jamaica", value: "JM" },
  { option: "Japan", value: "JP" },
  { option: "Jordan", value: "JO" },
  { option: "Kazakhstan", value: "KZ" },
  { option: "Kenya", value: "KE" },
  { option: "Kiribati", value: "KI" },
  { option: "Kuwait", value: "KW" },
  { option: "Kyrgyzstan", value: "KG" },
  { option: "Laos", value: "LA" },
  { option: "Latvia", value: "LV" },
  { option: "Lebanon", value: "LB" },
  { option: "Lesotho", value: "LS" },
  { option: "Liberia", value: "LR" },
  { option: "Libya", value: "LY" },
  { option: "Liechtenstein", value: "LI" },
  { option: "Lithuania", value: "LT" },
  { option: "Luxembourg", value: "LU" },
  { option: "Madagascar", value: "MG" },
  { option: "Malawi", value: "MW" },
  { option: "Malaysia", value: "MY" },
  { option: "Maldives", value: "MV" },
  { option: "Mali", value: "ML" },
  { option: "Malta", value: "MT" },
  { option: "Marshall Islands", value: "MH" },
  { option: "Mauritania", value: "MR" },
  { option: "Mauritius", value: "MU" },
  { option: "Mexico", value: "MX" },
  { option: "Micronesia", value: "FM" },
  { option: "Moldova", value: "MD" },
  { option: "Monaco", value: "MC" },
  { option: "Mongolia", value: "MN" },
  { option: "Montenegro", value: "ME" },
  { option: "Morocco", value: "MA" },
  { option: "Mozambique", value: "MZ" },
  { option: "Myanmar", value: "MM" },
  { option: "Namibia", value: "NA" },
  { option: "Nauru", value: "NR" },
  { option: "Nepal", value: "NP" },
  { option: "Netherlands", value: "NL" },
  { option: "New Zealand", value: "NZ" },
  { option: "Nicaragua", value: "NI" },
  { option: "Niger", value: "NE" },
  { option: "Nigeria", value: "NG" },
  { option: "North Korea", value: "KP" },
  { option: "North Macedonia", value: "MK" },
  { option: "Norway", value: "NO" },
  { option: "Oman", value: "OM" },
  { option: "Pakistan", value: "PK" },
  { option: "Palau", value: "PW" },
  { option: "Panama", value: "PA" },
  { option: "Papua New Guinea", value: "PG" },
  { option: "Paraguay", value: "PY" },
  { option: "Peru", value: "PE" },
  { option: "Philippines", value: "PH" },
  { option: "Poland", value: "PL" },
  { option: "Portugal", value: "PT" },
  { option: "Qatar", value: "QA" },
  { option: "Romania", value: "RO" },
  { option: "Russia", value: "RU" },
  { option: "Rwanda", value: "RW" },
  { option: "Saint Kitts and Nevis", value: "KN" },
  { option: "Saint Lucia", value: "LC" },
  { option: "Saint Vincent and the Grenadines", value: "VC" },
  { option: "Samoa", value: "WS" },
  { option: "San Marino", value: "SM" },
  { option: "Sao Tome and Principe", value: "ST" },
  { option: "Saudi Arabia", value: "SA" },
  { option: "Senegal", value: "SN" },
  { option: "Serbia", value: "RS" },
  { option: "Seychelles", value: "SC" },
  { option: "Sierra Leone", value: "SL" },
  { option: "Singapore", value: "SG" },
  { option: "Slovakia", value: "SK" },
  { option: "Slovenia", value: "SI" },
  { option: "Solomon Islands", value: "SB" },
  { option: "Somalia", value: "SO" },
  { option: "South Africa", value: "ZA" },
  { option: "South Korea", value: "KR" },
  { option: "South Sudan", value: "SS" },
  { option: "Spain", value: "ES" },
  { option: "Sri Lanka", value: "LK" },
  { option: "Sudan", value: "SD" },
  { option: "Suriname", value: "SR" },
  { option: "Sweden", value: "SE" },
  { option: "Switzerland", value: "CH" },
  { option: "Syria", value: "SY" },
  { option: "Taiwan", value: "TW" },
  { option: "Tajikistan", value: "TJ" },
  { option: "Tanzania", value: "TZ" },
  { option: "Thailand", value: "TH" },
  { option: "Timor-Leste", value: "TL" },
  { option: "Togo", value: "TG" },
  { option: "Tonga", value: "TO" },
  { option: "Trinidad and Tobago", value: "TT" },
  { option: "Tunisia", value: "TN" },
  { option: "Turkey", value: "TR" },
  { option: "Turkmenistan", value: "TM" },
  { option: "Tuvalu", value: "TV" },
  { option: "Uganda", value: "UG" },
  { option: "Ukraine", value: "UA" },
  { option: "United Arab Emirates", value: "AE" },
  { option: "United Kingdom", value: "GB" },
  { option: "United States", value: "US" },
  { option: "Uruguay", value: "UY" },
  { option: "Uzbekistan", value: "UZ" },
  { option: "Vanuatu", value: "VU" },
  { option: "Vatican City", value: "VA" },
  { option: "Venezuela", value: "VE" },
  { option: "Vietnam", value: "VN" },
  { option: "Yemen", value: "YE" },
  { option: "Zambia", value: "ZM" },
  { option: "Zimbabwe", value: "ZW" }
];
